import { render, staticRenderFns } from "./VoicesHeader.vue?vue&type=template&id=9e96383e&"
import script from "./VoicesHeader.vue?vue&type=script&lang=js&"
export * from "./VoicesHeader.vue?vue&type=script&lang=js&"
import style0 from "./VoicesHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports